import React from 'react';

function PageHero({
  title,
  subtitle,
  actions = null,
  children = null,
  className = '',
}) {
  const classes = ['card', 'page-hero', 'page-header', className].filter(Boolean).join(' ');

  return (
    <section className={classes}>
      {actions ? (
        <div className="row-between">
          <div>
            <h1 className="page-title">{title}</h1>
            {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
            {children}
          </div>
          {actions}
        </div>
      ) : (
        <div>
          <h1 className="page-title">{title}</h1>
          {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
          {children}
        </div>
      )}
    </section>
  );
}

export default PageHero;
